import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'react-redux';
import type { ProviderSummaryState } from './types';

export const providerSummary = (state: RootState) => state.providerSummary;

export const getIsFetchingProviderSummary = createSelector(
  providerSummary,
  (state: ProviderSummaryState) => state.isFetching,
);

export const getProviderSummary = createSelector(providerSummary, (state: ProviderSummaryState) => {
  return state.data;
});

export const getAiSummary = createSelector(
  providerSummary,
  (state: ProviderSummaryState) => state.data?.summary,
);
